// Adding or removing a set of ID and URL will also add or remove a card from the deck respectively.

export const images = [
    {
        id: 0,
        url: process.env.REACT_APP_LINK0,
    },
    {
        id: 1,
        url: process.env.REACT_APP_LINK1,
    },
    {
        id: 2,
        url: process.env.REACT_APP_LINK2,
    },
    {
        id: 3,
        url: process.env.REACT_APP_LINK3,
    },
]
